import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { subDays } from 'date-fns';
import {
    setFilterDate,
    setFilterCompare,
    setFilterDateCompare,
} from 'src/context/reducers/filter-settings/filterSlice';

// Pages under /brand/visibility that publish their own window and must not be
// overwritten here. Same convention as `routesWithOwnDateDefaults` in the header.
// Local is one: its period and comparison come from the two toolbar dropdowns,
// and child effects run before the parent's, so without this exception the
// layout clobbers the preset right after the page published it — the grid then
// queries a window the dropdown does not show.
const ROUTES_WITH_OWN_DATE_DEFAULTS = ['/brand/visibility/local'];

export default function VisibilityLayout() {
    const dispatch = useDispatch();
    const location = useLocation();
    const pageOwnsDates = ROUTES_WITH_OWN_DATE_DEFAULTS.includes(location?.pathname);

    useEffect(() => {
        if (pageOwnsDates) return;

        const now = new Date();
        dispatch(
            setFilterDate({
                start: subDays(now, 30).toISOString(),
                end: subDays(now, 1).toISOString(),
            })
        );
        dispatch(setFilterCompare(false));
        dispatch(
            setFilterDateCompare({
                compareStart: subDays(now, 60).toISOString(),
                compareEnd: subDays(now, 31).toISOString(),
            })
        );
    }, [dispatch, pageOwnsDates]);

    return <Outlet />;
}
